import { render, staticRenderFns } from "./Jokes.vue?vue&type=template&id=6427ea24&"
import script from "./Jokes.vue?vue&type=script&lang=js&"
export * from "./Jokes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports